import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import AceDentalLogo from './AceDentalLogo';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Showcase', path: '/showcase' },
    { name: 'Product', path: '/product' },
    { name: 'Workflow', path: '/workflow' },
    { name: 'Contact Us', path: '/contact' },
  ];
// bg-slate-900/95 backdrop-blur-sm border-b border-slate-800 z-50 border-b
  return (
    <header className="fixed top-0 w-full bg-black backdrop-blur-sm  border-slate-800 z-50    ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="/Images/Ace Dental Lab Logo Svg.svg" // 👈 yahan apka logo path dalna hai
              alt="Ace Dental Lab Logo"
              className="h-14 w-auto object-contain"
            />
          </Link>

          {/* // Header.jsx mein */}
{/* <Link to="/" className="flex items-center">
  <AceDentalLogo 
    className="h-12 w-auto" 
    size="medium" 
  />
</Link> */}

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`text-sm font-medium transition-colors duration-200 hover:text-white ${
                  location.pathname === item.path ? 'text-white' : 'text-gray-300'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Contact Info & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <div className="flex items-center text-sm text-gray-300">
              <Phone className="w-4 h-4 mr-2 text-white-400" />
              <span>(630) 866-1646</span>
            </div>
            <Link
              to="/contact"
              // from-blue0-600 
              className="bg-gradient-to-r  bg-white  to-cyan-500 text-black px-4 py-2 rounded-lg text-sm font-medium hover:from-white-700 hover:to-cyan-600 transition-all duration-200"
            >
              Send Case 
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-800">
            <nav className="flex flex-col space-y-3">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`text-sm font-medium px-2 py-1 rounded transition-colors duration-200 hover:text-blue-400 ${
                    location.pathname === item.path ? 'text-blue-400' : 'text-gray-300'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <div className="pt-3 border-t border-slate-800 mt-3">
                <div className="flex items-center text-sm text-gray-300 px-2 mb-3">
                  <Phone className="w-4 h-4 mr-2 text-blue-400" />
                  <span>(630) 866-1646</span>
                </div>
                <Link
                  to="/contact"
                  onClick={() => setIsMenuOpen(false)}
                  className="block bg-gradient-to-r from-blue-600 to-cyan-500 text-white px-4 py-2 rounded-lg text-sm font-medium text-center"
                >
                  Book Consultation
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;



